var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    rx: 40,
    ry: 40,
    width: 400,
    height: 400,
    fill: "#2563eb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 103,
    width: 38,
    height: 342,
    rx: 12,
    fill: "#06b6d4",
    opacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 160,
    width: 280,
    height: 36,
    rx: 8,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 238,
    width: 280,
    height: 36,
    rx: 8,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 316,
    width: 280,
    height: 36,
    rx: 8,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d507753beef03a8cebcad836b78aa66e.svg";
export { ForwardRef as ReactComponent };